exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".success_page[data-v-3e6931a0]{padding:50px 0;line-height:35px}.success_page .btns[data-v-3e6931a0]{margin-top:20px}\n", ""]);

// exports
